import { OrderUnitOfMeasure } from '@treadinc/horizon-api-spec';
import { useMemo } from 'react';

import { unitOfMeasureOptions } from '~constants/enums';
import { useStores } from '~store';

// A shared constant, not a fresh `[]` per call: this value feeds a useMemo below
// and, through it, effect dependency arrays. A new array identity on every render
// makes those effects re-run forever.
const NO_ALLOWED_UNITS: OrderUnitOfMeasure[] = [];

export function useAllowedOrderUnitOfMeasures(): OrderUnitOfMeasure[] {
  const { userStore } = useStores();
  return userStore.userCompany?.allowedOrderUnitsOfMeasure ?? NO_ALLOWED_UNITS;
}

export function useAllowedUnitOfMeasureOptions() {
  const allowedUnits = useAllowedOrderUnitOfMeasures();

  return useMemo(() => {
    if (allowedUnits.length === 0) return unitOfMeasureOptions;
    return unitOfMeasureOptions.filter(({ id }) =>
      allowedUnits.includes(id as OrderUnitOfMeasure),
    );
  }, [allowedUnits]);
}
